import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Country, LegalDocument, LegalDocumentTypeEnum, SURGEON_CODE } from '../core';
import { UserRequestService } from '../services';
import { BaseComponent } from '../shared';


/**
* Page for legal terms reading.
*/
@Component({
	selector: 'app-legal-terms-page',
	templateUrl: './legal-terms-page.component.html',
	imports: [
		FormsModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class LegalTermsPageComponent extends BaseComponent implements OnInit {

	private readonly route = inject(ActivatedRoute);
	private readonly userSrv = inject(UserRequestService);
	private readonly titleSrv = inject(Title);

	private readonly DEFAULT_COUNTRY_CODE: string = 'GB';

	countryCode = this.DEFAULT_COUNTRY_CODE;

	countryList: Country[] = [];
	docList: LegalDocument[] = [];
	eulaText: string = '';
	privacyPolicyText: string = '';
	dpaText: string = '';


	ngOnInit(): void {
		this.titleSrv.setTitle(this.labels().APP_LEGAL_TERMS_TITLE);
		this.userSrv.getCountries().subscribe(list => {
			this.countryList = list;
			this.initCountryCode();
			this.updateDocuments();
		});
	}

	private initCountryCode(): void {
		const code = this.route.snapshot.queryParamMap.get('countryCode');
		const country = this.countryList.find(i => i.code === code);
		this.countryCode = country?.code ?? this.DEFAULT_COUNTRY_CODE;
	}

	/**
	* Update document list when country selection change.
	*/
	updateDocuments(): void {
		this.userSrv.getLegalDocuments(this.countryCode, SURGEON_CODE).subscribe(docs => {
			this.docList = docs;
			this.eulaText = this.docList.find(doc => doc.type === LegalDocumentTypeEnum.EULA)?.text ?? '';
			this.privacyPolicyText = this.docList.find(doc => doc.type === LegalDocumentTypeEnum.PrivacyPolicy)?.text ?? '';
			this.dpaText = this.docList.find(doc => doc.type === LegalDocumentTypeEnum.DPA)?.text ?? '';
		});
	}
}
